import { cn } from '@tebuto/lib/utils'
import { DateTime } from 'luxon'
import { useContext } from 'react'
import { calendarCellDayKey, eventDayKey } from './calendar-day'
import { BookingCalendarContext } from './context'

export default function Day({ day }: { day: DateTime<true> }) {
    const { selectedDate, setSelectedDate, filteredEvents } = useContext(BookingCalendarContext)

    const isCurrentMonth = day.hasSame(selectedDate, 'month')
    const dayHasEvents = filteredEvents?.some((event) => eventDayKey(event.startDatetime) === calendarCellDayKey(day))
    const isSelected = selectedDate?.hasSame(day, 'day')
    const isToday = day.hasSame(DateTime.now(), 'day')

    const isoDate = day.toISODate()

    return (
        <div
            onClick={() => setSelectedDate(day)}
            key={isoDate ?? day.toISO()}
            data-date={isoDate ?? undefined}
            className={cn(
                'flex mx-auto justify-center font-medium items-center size-9 text-sm rounded-full border-2 border-transparent cursor-pointer transition-all duration-300',
                dayHasEvents ? 'widget-bg-calendar-available-day' : 'widget-bg-calendar-unavailable-day',
                dayHasEvents && !isSelected ? 'widget-text-primary-color-800' : '',
                !isCurrentMonth ? 'opacity-40' : '',
                isSelected ? 'widget-bg-primary-600 widget-text-on-primary' : 'widget-text-secondary',
                isToday ? 'widget-border-primary-700' : ''
            )}
        >
            {day.toFormat('dd')}
        </div>
    )
}
